'use client';

import classnames from 'classnames';

import type { BaseComponentProps } from '../base-component.types';
import { Logo } from '../logo';

import styles from './Splash.module.scss';

type SplashProps = BaseComponentProps & {
  /** Float above the page behind a blurred scrim instead of replacing it. */
  overlay?: boolean;
};

function Splash({
  className,
  overlay = false,
  testId = 'ui-splash',
}: SplashProps) {
  return (
    <div
      className={classnames(
        styles['main'],
        overlay && styles['main--overlay'],
        className,
      )}
      data-testid={testId}
    >
      <Logo className={styles['logo']} variant="logo-h" />
    </div>
  );
}

export { Splash, type SplashProps };
